/**
 * Restaurants Module
 *
 * Handles restaurant management functionality including:
 * - List filters
 * - Form validation
 */

import { $, ready } from '../utils/dom.js';

const BASE_URL = '/restaurants';

// =============================================================================
// Filters
// =============================================================================

/**
 * Apply status filter
 * @param {HTMLSelectElement} select
 */
export function applyStatusFilter(select) {
    const status = select.value;
    const params = new URLSearchParams();

    if (status) params.append('status', status);

    window.location.href = BASE_URL + (params.toString() ? '?' + params.toString() : '');
}

/**
 * Clear all filters
 */
export function clearFilters() {
    window.location.href = BASE_URL;
}

// =============================================================================
// Form Validation
// =============================================================================

/**
 * Initialize restaurant form validation
 */
function initRestaurantFormValidation() {
    const form = $('#restaurant-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
        const name = $('#name')?.value.trim();
        const slug = $('#slug')?.value.trim();

        if (!name) {
            alert('Please enter a restaurant name');
            e.preventDefault();
            return;
        }

        if (!slug) {
            alert('Please enter a URL slug');
            e.preventDefault();
            return;
        }

        // Validate slug format
        if (!/^[a-z0-9-]+$/.test(slug)) {
            alert('Slug can only contain lowercase letters, numbers, and hyphens');
            e.preventDefault();
            return;
        }
    });
}

/**
 * Initialize slug auto-generation from name
 */
function initSlugGeneration() {
    const nameInput = $('#name');
    const slugInput = $('#slug');

    if (!nameInput || !slugInput) return;

    nameInput.addEventListener('input', function() {
        // Only auto-generate if slug is empty or matches previous auto-generated value
        if (!slugInput.dataset.userEdited) {
            const slug = nameInput.value
                .toLowerCase()
                .replace(/[^a-z0-9\s-]/g, '')
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-')
                .replace(/^-|-$/g, '');
            slugInput.value = slug;
        }
    });

    // Mark as user-edited if manually changed
    slugInput.addEventListener('input', function() {
        slugInput.dataset.userEdited = 'true';
    });
}

// =============================================================================
// Auto-Initialization
// =============================================================================

function initRestaurants() {
    initRestaurantFormValidation();
    initSlugGeneration();
}

ready(initRestaurants);

// Expose globally - but don't override if already set (for admin page)
if (!window.applyStatusFilter) {
    window.applyStatusFilter = applyStatusFilter;
}
if (!window.clearFilters) {
    window.clearFilters = clearFilters;
}

export default {
    applyStatusFilter,
    clearFilters
};
